import Shipment from 'interfaces/PmParcel';
import { useTranslation } from 'react-i18next';
import {
  isReturnShipment,
  getShipmentDisplayFactory,
  ShipmentDisplay,
} from 'utils/shipmentDisplay.utils';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { ItemForward, ItemReturn } from './components';

export interface DisplayItemProps {
  baseShipment: Shipment;
  numberOfShipment?: number;
  isActiveShipment?: boolean;
  isDropdownItem?: boolean;
  index?: number;
  onSelectShipment?: (selectedShipment: Shipment) => void;
}

const DisplayItem: React.FC<DisplayItemProps> = (props) => {
  const configs = usePTPConfigContext();
  const { t } = useTranslation();

  const formatSingleShipmentHeadingLabel = (currentShipment: Shipment) => {
    const currentShipmentDisplayFactory = getShipmentDisplayFactory(
      configs,
      currentShipment,
      t,
    );

    let str = currentShipmentDisplayFactory(ShipmentDisplay.twoParcels);

    /**
     * Temporary solution, waiting for the final design.
     * In case "Open shipment" does not have a tracking number or other reference, use the shipment id instead of empty text.
     */
    if (!str) {
      str = currentShipment?.shipmentId || '';
    }

    return str;
  };

  const Component = isReturnShipment(props.baseShipment)
    ? ItemReturn
    : ItemForward;

  return (
    <Component
      {...props}
      formatShipmentHeadingLabel={formatSingleShipmentHeadingLabel}
    />
  );
};

export default DisplayItem;
